SupportGiftOrderPopupView = require('../gift_order_popup_view')
SupportServiceActionsBaseView = require('./service_action_base')
SupportServiceActionButtonTemplate = require('../../../../service_action_button.html.mustache')

class SupportGiftOrderServiceActionView extends SupportServiceActionsBaseView
  id: 'gift_to_friend'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportServiceActionButtonTemplate
    @order = Groupon.Support.currentOrder
    @attributes = @options.userId

  render: ->
    hash =
    @$el.append toHtml(@template, @toHash(), @I18nScope)

  toHash: ->
    hash =
      service_action_id : "gift_order",
      service_action : I18n.t("js.modules.support.gift_order")
    @extendHash(hash)

  actionHandler: (event)->
    current_order = Groupon.Support.currentOrder

    dealPermalink = current_order.deal.id
    orderId = current_order.id
    url = "/deals/#{ dealPermalink }/confirmation?pledge_id=#{current_order.dealOptionId}"
    window.open(url);
    @popup = new SupportGiftOrderPopupView()

  events:
    "click #gift_order"  : "actionHandler"

module.exports = SupportGiftOrderServiceActionView
